let _isReactNative = false

export function isReactNative() {
  return _isReactNative
}

export function setIsReactNative(value) {
  _isReactNative = value
}
